export const hasScheduleDetails = ({ context }) => !!context.schedulePattern && !!context.tutorId;
export const isWithinEffectivePeriod = ({ context }) => {
    const now = new Date();
    const from = context.effectiveFrom ? new Date(context.effectiveFrom) : null;
    const to = context.effectiveTo ? new Date(context.effectiveTo) : null;
    if (!from || !to)
        return false;
    return now >= from && now <= to;
};
export const hasRejectionReason = ({ context }) => !!context.rejectionReason;
export const hasCancellationReason = ({ context }) => !!context.cancellationReason;
//# sourceMappingURL=tutoring-schedule.js.map